<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses" content="notranslate" translate="no">
    <router-view @setAppClasses="setAppClasses" :key="$route.fullPath" />
    <alert-dialog />
    <loading-dialog />
    <q-r-auth-dialog />

    <!-- 로그인 팝업(입력 안된 회원정보) -->
    <!-- <vs-popup :active.sync="popupMypage.show" title="알림">
      <div class="flex flex-col items-center justify-center gap-5 text-center p-5 pt-2 break-words">
        <p style="font-size: 24px; font-weight: 500">입력되지 않은 회원 정보가 있습니다.</p>
        <p>
          입력 페이지로 이동하여 나머지 회원 정보를 입력해주세요. (서명, 신분증 사진 등)<br />
          *경로 : 마이페이지_설정_개인정보변경
        </p>
        <vs-checkbox v-model="popupMypage.checkSkipForAWeek">일주일간 보지 않기</vs-checkbox>
        <div class="flex gap-2 justify-center">
          <vs-button color="secondary" type="border" @click="() => handleMypageBtn('닫기')">닫기</vs-button>
          <vs-button color="secondary" @click="() => handleMypageBtn('이동')">입력페이지로 이동</vs-button>
        </div>
      </div>
    </vs-popup> -->
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import AlertDialog from "@/components/AlertDialog.vue";
import LoadingDialog from "@/components/LoadingDialog.vue";
import QRAuthDialog from "@/components/QRAuthDialog.vue";

export default {
  components: {
    AlertDialog,
    LoadingDialog,
    QRAuthDialog,
  },
  data() {
    return {
      vueAppClasses: [],
      qrCodeBackgroundUrl: require("/public/qr-bg-white.png"),

      popupMypage: {
        one: true, // 한번만 체크하기
        show: false,
        checkSkipForAWeek: false,
      },
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className === "dark") {
        if (document.body.className.match("theme-semi-dark")) document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className === "semi-dark") {
        if (document.body.className.match("theme-dark")) document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark")) document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark")) document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },

    handleMypageBtn(type) {
      if (this.popupMypage.checkSkipForAWeek) this.$cookies.set("checkMypagePopupHidden", "1", "7d");

      if (type === "닫기") {
        this.popupMypage.show = false;
      } else {
        this.popupMypage.show = false;
        window.location.href = "/mypage/info-update";
      }
    },

    transformToMeta(metas) {
      const meta = {};

      metas.forEach(({ meta_key, meta_value }) => {
        const keys = meta_key.split(".");
        let current = meta;

        // Traverse or create nested objects
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            // Check if value is numeric and convert
            current[key] = /^\d+$/.test(meta_value) ? Number(meta_value) : meta_value;
          } else {
            if (!current[key]) {
              current[key] = {}; // Create a new object if not exists
            }
            current = current[key];
          }
        });
      });

      return meta;
    },
  },
  async mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // 입력되지 않은 회원정보 체크 후 팝업 띄우기
    // checkLogin 로그인 후 12시간 유효한 쿠키 / 다른 board로 넘어갈때 새 탭으로 불려오기때문에 계속해서 팝업이 뜨는걸 막기위해 넣어줌
    if (this.popupMypage.one && this.$cookies.get("checkLogin") && !this.$cookies.get("checkMypagePopupHidden")) {
      return;
      await this.$nextTick();

      this.$cookies.remove("checkLogin");

      this.popupMypage.one = false;
      const memberInfo = await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
      const metas = this.transformToMeta(memberInfo.metas);
      if (!metas) return;

      // 데이터가 없으면 true 리턴
      const isKeyMissingOrEmpty = (obj, key) => {
        return Object.keys(obj).length === 0 || !(key in obj) || obj[key] === null || obj[key] === undefined || obj[key] === "";
      };

      // 사업장, 담당부서, 이름, 주민번호, 휴대폰번호, 직책, 직종, 건설업기초교육, 교육이수번호, 서명, 신분증
      // userData.meta.registerType가 일용직인 경우 업체를 체크하지 않음
      // 장비운전자가 체크되어있지 않으면 면허증을 체크하지 않음
      const requiredKeys = ["rrn", "건설업기초안전교육", "교육이수번호", "서명", "신분증사진"];
      const memberRequiredKeys = ["name", "phone"];
      const equipmentKeys = ["건설기계조종사면허번호", "건설기계조종사면허증사진"];

      // 필수 값 체크
      const isMissingRequired = requiredKeys.some((key) => isKeyMissingOrEmpty(metas, key)) || memberRequiredKeys.some((key) => isKeyMissingOrEmpty(memberInfo, key));
      const isMissingCompany = (!isKeyMissingOrEmpty(metas, "registerType") && metas.registerType !== "일용직") || isKeyMissingOrEmpty(metas, "업체");
      const isEquipmentDriver = metas.장비운전자 === "true" && (isKeyMissingOrEmpty(metas, "장비운전자") || equipmentKeys.some((key) => isKeyMissingOrEmpty(metas, key)));

      if (isMissingRequired || isMissingCompany || isEquipmentDriver) {
        this.popupMypage.show = true;
      }
    }
  },
  async created() {
    const dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    // i18n 초기설정
    this.$i18n.locale = "ko_maot";

    // qr 배경색 이미지
    document.documentElement.style.setProperty("--qr-code-background-url", `url(${this.qrCodeBackgroundUrl})`);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
.vs-textarea-primary textarea {
  resize: vertical !important;
}

.vs-textarea-primary.resize-none textarea {
  resize: none !important;
}

.vs-popup {
  position: fixed;
}

.qr-code {
  /* 강제로 라이트 모드 배경 적용 */
  background-color: #ffffff !important;
  /* 다크모드에서 색상 반전 방지 */
  -webkit-forced-color-adjust: none !important;
  forced-color-adjust: none !important;
  /* 색상 스키마 강제 적용 */
  color-scheme: light !important;
  /* 색상 반전 필터 방지 */
  -webkit-filter: none !important;
  filter: none !important;

  background-image: var(--qr-code-background-url);
  background-repeat: repeat; /* 배경 반복 */
  background-size: auto; /* 기본 크기 유지 */
  background-position: top left; /* 시작 위치 */

  img {
    padding: 10px;
    border: 1px solid #ccc;

    /* QR 코드 이미지에도 동일한 속성 적용 */
    -webkit-forced-color-adjust: none !important;
    forced-color-adjust: none !important;
    /* 색상 반전 방지 */
    -webkit-filter: none !important;
    filter: none !important;
  }

  /* 다크모드 대응 */
  @media (prefers-color-scheme: dark) {
    .qr-code {
      /* 다크모드에서도 흰색 배경 유지 */
      background-color: #ffffff !important;
    }
  }
}
</style>
